import * as React from "react"
import { Moon, Sun } from "lucide-react"
import { useTheme } from "next-themes"

import { Button } from "@/components/ui/button"

export function ThemeToggle() {
  const { setTheme, theme } = useTheme()
  const [mounted, setMounted] = React.useState(false)

  // useEffect only runs on the client, so now we can safely show the UI
  React.useEffect(() => {
    setMounted(true)
  }, [])

  // Force theme to be "dark" or "light" only - never allow "system"
  React.useEffect(() => {
    if (mounted && theme && theme !== "dark" && theme !== "light") {
      setTheme("dark")
    }
  }, [mounted, theme, setTheme])

  const cycleTheme = () => {
    if (!mounted) return
    
    const currentTheme = theme === "dark" ? "dark" : "light"
    if (currentTheme === "dark") {
      setTheme("light")
    } else {
      setTheme("dark")
    }
  }

  if (!mounted) {
    return (
      <Button variant="ghost" size="icon" className="h-9 w-9 text-foreground hover:bg-muted">
        <Moon className="h-4 w-4" />
      </Button>
    )
  }

  const getIcon = () => {
    // Show icon for the theme we'll switch TO, not current theme
    // In light mode, show moon (to switch to dark)
    // In dark mode, show sun (to switch to light)
    if (theme === "light") {
      return <Moon className="h-4 w-4" />
    } else {
      return <Sun className="h-4 w-4" />
    }
  }

  return (
    <Button 
      variant="ghost" 
      size="icon" 
      className="h-9 w-9 text-foreground hover:bg-muted"
      onClick={cycleTheme}
    >
      {getIcon()}
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}

